import axios from "axios";

const base = process.env.REACT_APP_BACK_URL || `${window.location.protocol}//${window.location.hostname}:5000`;

export const getResumenCajas = async () => {
  const { data } = await axios.get(`${base}/dashboard/cajas/resumen`);
  return data;
};

export const getOcupacionPorTamano = async () => {
  const { data } = await axios.get(`${base}/dashboard/cajas/ocupacion-por-tamano`);
  return data;
};

export const getPorcentajeDeuda = async (anio?: number, periodo?: number) => {
  const { data } = await axios.get(`${base}/dashboard/pagos/porcentaje-deuda`, {
    params: {
      anio,
      periodo,
    },
  });
  return data;
};

export const getDeudaPorMes = async (anio: number) => {
  const { data } = await axios.get(`${base}/dashboard/pagos/deuda-por-mes/${anio}`);
  return data;
};

export type InicioResumenSocio = {
  socioId: number;
  deudaTotal: number;
  puntosTotal: number;
  cuponesAsignados: number;
  misCupones: any[];
};

export const getInicioResumenSocio = async (
  socioId: number | string,
  token: string
): Promise<InicioResumenSocio> => {
  const { data } = await axios.get<InicioResumenSocio>(
    `${base}/dashboard/socio/${socioId}/inicio-resumen`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};
